import { Box, styled } from "@acko-tech/building-blocks.ui.common";
import { Text } from "@acko-tech/building-blocks.ui.typography";

export const DidYouKnowAddonHeading = styled(Text)`
  color: #040222;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin-top: 16px;
  margin-left: 0px;
`;

export const DidYouKnowAddonDesc = styled(Text)`
  color: #040222;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  span {
    font-weight: 600;
  }
  .price-text {
    color: #d83d37;
  }
`;

export const ButtonContainer = styled(Box)`
  border-radius: 24px 24px 0px 0px;
  background: #f8f7fc;
  box-shadow: 0px -1px 1px 0px #efe9fb;
  display: flex;
  padding: 20px 20px 24px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-sizing: border-box;
  margin-top: 32px;

  @media (max-width: 768px) {
    // width: 100%;
  }
       @media (min-width: 768px) {
     padding: 32px;
  }
`;

export const DidYouKnowAddonWrapper = styled(Box)`
  padding: 0px 20px 0px 20px;
   @media (min-width: 768px) {
    padding: 0px 32px 0px 32px;
  }
`;
